import { State, process } from '@progress/kendo-data-query';
import { Grid, GridDataStateChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import React, { createRef, useCallback, useMemo, useState } from 'react';
import useGlCodeMismatchColumns from 'src/assets/static/view_invoice/useGlCodeMismatchColumns';
import GridWrapper from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';
import useInvoiceLineItemsApi, { InvoiceLineItem } from '../../services/useInvoiceLineItemsApi';

const gridPagerSettings: GridPagerSettings = {
  buttonCount: 5,
  pageSizes: [10, 20, 50, 100],
};
const defaultProps = {
  showColumnMenu: false,
  resizable: true,
  sortable: false,
  pageable: gridPagerSettings,
  DataItemKey: 'receiptLineItemId',
};

interface IGLCodeMismatchWizard {
  invoiceId: string;
  invoiceNumber?: string | number;
  poNum?: string;
}

const GLCodeMismatchWizard: React.FC<IGLCodeMismatchWizard> = ({
  invoiceId,
  invoiceNumber,
  poNum,
}) => {
  const { invoiceLineItems, isInvoiceLineItemsLoading } = useInvoiceLineItemsApi(
    invoiceId,
    invoiceNumber,
    poNum
  );
  const initialGlCodeMisMatchDataState: State & { skipCalculatingTotalRecordsCount: boolean } = {
    skip: 0,
    take: 20,
    skipCalculatingTotalRecordsCount: false,
    sort: [],
    filter: {
      filters: [],
      logic: 'and',
    },
  };

  const { height } = useWindowSize();
  const tableRef = createRef<Grid>();
  const columns = useGlCodeMismatchColumns(tableRef);
  const [dataState, setDataState] = useState<State>(initialGlCodeMisMatchDataState);
  const { data, total } = useMemo(
    () =>
      process(invoiceLineItems.filter((i) => i.poGlCd !== i.glCd) || [], dataState) as {
        data: InvoiceLineItem[];
        total: number;
      },
    [dataState, invoiceLineItems]
  );

  const onGlMismatchDataStateChange = useCallback(
    (e: GridDataStateChangeEvent) => setDataState(e.dataState),
    []
  );
  return (
    <>
      <div className="mt-1 mb-1 px-1">
        <GridWrapper
          id="glCodeMismatchGrid"
          loading={isInvoiceLineItemsLoading}
          height={height > 420 ? '75vh' : '700px'}
          columns={columns}
          ref={tableRef}
          dataSource={data || []}
          dataState={dataState}
          total={total}
          onDataStateChange={onGlMismatchDataStateChange}
          {...defaultProps}
          className="glCodeMismatchGrid viewInvoiceModalGrid"
        />
      </div>
    </>
  );
};

export default GLCodeMismatchWizard;
